import {Component, Injector, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {ModalFormComponentInterface} from '@interfaces/modal-form-component.interface';
import {ModalComponent} from '@components/modal/modal.component';
import {ConclusionApiService} from '@api/conclusion.api.service';
import {ConclusionFormDataService} from '../../services/conclusion-form-data.service';
import {
    DynamicFieldsGroupComponent
} from '@subforms/dynamic-fields/components/dynamic-fields-group/dynamic-fields-group.component';
import {DynamicFields} from '@namespaces/dynamic-fields.namespace';
import {ActivatedRoute, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {untilDestroyed} from 'ngx-take-until-destroy';

@Component({
    selector: 'app-conclusion-form-inspection-params-form-modal',
    templateUrl: './conclusion-form-inspection-params-form-modal.component.html',
})
export class ConclusionFormInspectionParamsFormModalComponent
    extends FrontendFormComponent implements ModalFormComponentInterface, OnDestroy {

    public isFetching = true;

    public form = this._fb.group({
        count: [1],
        params: this._fb.array([]),
    });

    @ViewChild(ModalComponent) modal: ModalComponent;
    @ViewChild(DynamicFieldsGroupComponent) paramsFields: DynamicFieldsGroupComponent;

    public modalTitle = 'Параметры контроля';

    public hasInspections = false;

    constructor(
        injector: Injector,
        public formService: ConclusionApiService,
        private dataService: ConclusionFormDataService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        super(injector);
    }

    get saveUrl(): string {
        return this.formService.getInspectionBatchCreatePath(this.dataService.conclusionId);
    }

    init() {
        this.formService.get({
            url: this.formService.getInspectionBatchParamsPath(this.dataService.conclusionId)
        }).subscribe((fields: DynamicFields.Field[]) => {
            this.paramsFields.setGroupStructure(fields || []);
            this.isFetching = false;
        }, () => {
            this.isFetching = false;
        });

        this.dataService.inspectionsList$.pipe(
            map(v => Boolean(v) && Boolean(v.length)),
            untilDestroyed(this),
        ).subscribe((has: boolean) => {
            this.hasInspections = has;
        }, () => {

        });
    }

    onModalClose() {
        this.router.navigate([{outlets: {modal: null}}], {relativeTo: this.route.parent});
    }


    afterSave() {
        this.isPending = false;
        this.dataService.updateInspectionForm(true);
        this.modal.close();
    }

    ngOnDestroy() {

    }

}
